<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        title="BatchRun"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/BatchRun/CoreBatchRunDetail"
        :parent-component="$options.name"
        :main-validator="true"
    >
      <template v-slot:item.notion_id="{ item }">
        <v-icon
                v-if="item.notion_id != null"
                color="primary"
                size="20"
                @click="onNotion(item)"
            >
              mdi-alpha-n-box-outline
            </v-icon>
      </template>
      <template v-slot:item.customer_order__name="{ item }">
        <span v-if="!!item.customer_order_uid && storeAggregate.rootData">
          {{storeAggregate.rootData[item.customer_order_uid].name}}
        </span>
      </template>
      <template v-slot:item.product_order__name="{ item }">
        <span v-if="!!item.product_order_uid && storeAggregate.rootData">
          {{storeAggregate.rootData[item.product_order_uid].name}}
        </span>
      </template>
      <template v-slot:item.product_order__customer_order__name="{ item }">
        <span v-if="storeAggregate.rootData && !!item.product_order_uid && !!storeAggregate.rootData[item.product_order_uid].customer_order_uid">
          {{storeAggregate.rootData[storeAggregate.rootData[item.product_order_uid].customer_order_uid].name}}
        </span>
      </template>

      <template v-slot:footer.middle>
        <v-chip v-if="!!storeTable && !!storeTable.common && !!storeTable.common.data" label class="mx-1">
          Σ Price = {{ storeTable.common.data.price_sum }}
        </v-chip>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreBatchRunDetail from "@/components/CoreComponent/BatchRun/CoreBatchRunDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";

export default {
  name: "CoreBatchRunTable",

  props: {
    embedded: {default: false},
    storeName: {type: [String], default: 'BatchRunTable'},
    dtoDetailQuery: {default: 'BatchRunDetailQueryDTO'},
    detailStoreName: {default: 'BatchRunDetail'},
    dtoValidateCommand: {type: [String], default: 'BatchRunValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'BatchRunListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'BatchRunActionCommandDTO'},
    // dtoSaveCommand: {type: [String], default: 'SimpleSaveCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    CoreBatchRunDetail,
    BaseFieldCheck,
  },

  methods: {
    onNotion(item) {
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'N', value: 'notion_id', sortable: true, filterable: true, divider: true, width: 30},
      {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true, width: 450},
      {text: 'Order', value: 'order', sortable: true, filterable: true, divider: true, width: 70},
      {text: 'Status', value: 'status', sortable: true, filterable: true, divider: true, width: 150},
      {text: 'Reservation status', value: 'reservation_status', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'Delivery date', value: 'delivery_date', sortable: true, filterable: true, divider: true, type: 'date'},
      {text: 'Lot size SMD', value: 'lot_size_smd', sortable: true, filterable: true, divider: true},
      {text: 'Lot size THT', value: 'lot_size_tht', sortable: true, filterable: true, divider: true},

      {text: 'Board price', value: 'board_price', sortable: true, filterable: true, divider: true},
      {text: 'Price', value: 'price', sortable: true, filterable: true, divider: true},
      {text: 'Year/week', value: 'year_week', sortable: true, filterable: true, divider: true},
      {text: 'Start week', value: 'start_week', sortable: true, filterable: true, divider: true},

      {text: 'Customer order', value: 'customer_order__name', sortable: true, filterable: true, divider: true, width: 350},
      {text: 'Product order - Customer order', value: 'product_order__customer_order__name', sortable: true, filterable: true, divider: true, width: 350},
      {text: 'Product order', value: 'product_order__name', sortable: true, filterable: true, divider: true, width: 350},
      {text: 'In production', value: 'in_production', sortable: true, filterable: true, divider: true, width: 30, type: 'bool'},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      // this.storeTable.dtoSaveCommand = this.dtoSaveCommand
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>